import script from "./ConfirmHost.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmHost.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmHost.vue?vue&type=style&index=0&id=4c507871&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c507871"]])

export default __exports__